import { ARCHIVED_STATUS } from "@/constants";

export const updateUnitAndRoomsStatus = (unit, status) => {
  unit.status = status;
  unit.rooms.forEach((room) => {
    if (room.status !== ARCHIVED_STATUS) {
      room.status = status;
    }
  });
};
